import { render, staticRenderFns } from "./PayslipView.vue?vue&type=template&id=c642f78e&scoped=true"
import script from "./PayslipView.vue?vue&type=script&lang=js"
export * from "./PayslipView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642f78e",
  null
  
)

export default component.exports